import React from 'react';
import {getCurrentFormStatusColor, getStatusBorderColor} from '../../../Form/utils/status';
import styles from './styles.module.scss';

export const StatusCircle = ({status}) => {
    const color = getCurrentFormStatusColor(status);
    const borderColor = getStatusBorderColor(color);

    return (
        <div
            className={styles.statusCircle}
            style={{backgroundColor: color, borderColor: borderColor}}
        />
    );
};
